/* unplugin-vue-components disabled */import { render } from "./HomeWorkView.vue?vue&type=template&id=fe6faf32&scoped=true"
import script from "./HomeWorkView.vue?vue&type=script&lang=js"
export * from "./HomeWorkView.vue?vue&type=script&lang=js"

import "./HomeWorkView.vue?vue&type=style&index=0&id=fe6faf32&lang=scss&scoped=true"

import exportComponent from "../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe6faf32"]])

export default __exports__